import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _cffe3db6 = () => interopDefault(import('~/pages/_.vue' /* webpackChunkName: "" */))
const _fe9de024 = () => interopDefault(import('../../../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/contact-us",
    component: _cffe3db6,
    name: "contact-us"
  }, {
    path: "/copyright",
    component: _cffe3db6,
    name: "copyright"
  }, {
    path: "/areas-of-expertise/business-exit-planning",
    component: _cffe3db6,
    name: "business-exit-planning"
  }, {
    path: "/areas-of-expertise/business-strategies",
    component: _cffe3db6,
    name: "business-strategies"
  }, {
    path: "/areas-of-expertise/employee-benefits",
    component: _cffe3db6,
    name: "employee-benefits"
  }, {
    path: "/areas-of-expertise/financial-planning",
    component: _cffe3db6,
    name: "financial-planning"
  }, {
    path: "/areas-of-expertise/personal-planning",
    component: _cffe3db6,
    name: "personal-planning"
  }, {
    path: "/areas-of-expertise/solutions-for-physicians",
    component: _cffe3db6,
    name: "solutions-for-physicians"
  }, {
    path: "/areas-of-expertise/wealth-management",
    component: _cffe3db6,
    name: "wealth-management"
  }, {
    path: "/business-strategies-additional-information/business-continuation-planning",
    component: _cffe3db6,
    name: "business-continuation-planning"
  }, {
    path: "/business-strategies-additional-information/business-strategies---employee-benefits",
    component: _cffe3db6,
    name: "business-strategies---employee-benefits"
  }, {
    path: "/business-strategies-additional-information/exit-planning",
    component: _cffe3db6,
    name: "exit-planning"
  }, {
    path: "/business-strategies-additional-information/helping-your-business-grow",
    component: _cffe3db6,
    name: "helping-your-business-grow"
  }, {
    path: "/business-strategies-additional-information/life-insurance",
    component: _cffe3db6,
    name: "life-insurance"
  }, {
    path: "/business-strategies-additional-information/retirementestate-planning",
    component: _cffe3db6,
    name: "retirementestate-planning"
  }, {
    path: "/client-education/about-the-nautilus-group",
    component: _cffe3db6,
    name: "about-the-nautilus-group"
  }, {
    path: "/client-education/combined-video-library",
    component: _cffe3db6,
    name: "combined-video-library"
  }, {
    path: "/client-education/concepts-and-strategies",
    component: _cffe3db6,
    name: "concepts-and-strategies"
  }, {
    path: "/employee-benefits-additional-information/flexible-spending-accounts",
    component: _cffe3db6,
    name: "flexible-spending-accounts"
  }, {
    path: "/employee-benefits-additional-information/group-dentalvision-plans",
    component: _cffe3db6,
    name: "group-dentalvision-plans"
  }, {
    path: "/employee-benefits-additional-information/group-disability-plans",
    component: _cffe3db6,
    name: "group-disability-plans"
  }, {
    path: "/employee-benefits-additional-information/group-life-plans",
    component: _cffe3db6,
    name: "group-life-plans"
  }, {
    path: "/employee-benefits-additional-information/group-major-medical-plans",
    component: _cffe3db6,
    name: "group-major-medical-plans"
  }, {
    path: "/employee-benefits-additional-information/retirement-plans",
    component: _cffe3db6,
    name: "retirement-plans"
  }, {
    path: "/employee-benefits-additional-information/voluntary-coverage",
    component: _cffe3db6,
    name: "voluntary-coverage"
  }, {
    path: "/personal-planning-additional-information/401k-and-ira-rollovers",
    component: _cffe3db6,
    name: "401k-and-ira-rollovers"
  }, {
    path: "/personal-planning-additional-information/asset-protection",
    component: _cffe3db6,
    name: "asset-protection"
  }, {
    path: "/personal-planning-additional-information/charitable-planning",
    component: _cffe3db6,
    name: "charitable-planning"
  }, {
    path: "/personal-planning-additional-information/disability-and-long-term-care",
    component: _cffe3db6,
    name: "disability-and-long-term-care"
  }, {
    path: "/personal-planning-additional-information/estate-planning-strategies",
    component: _cffe3db6,
    name: "estate-planning-strategies"
  }, {
    path: "/personal-planning-additional-information/funding-a-college-education",
    component: _cffe3db6,
    name: "funding-a-college-education"
  }, {
    path: "/personal-planning-additional-information/inheritances",
    component: _cffe3db6,
    name: "inheritances"
  }, {
    path: "/solutions-for-physicians-additional-info/disability-extended-care-needs",
    component: _cffe3db6,
    name: "disability-extended-care-needs"
  }, {
    path: "/solutions-for-physicians-additional-info/for-practicing-physicians",
    component: _cffe3db6,
    name: "for-practicing-physicians"
  }, {
    path: "/solutions-for-physicians-additional-info/for-residents-and-fellows",
    component: _cffe3db6,
    name: "for-residents-and-fellows"
  }, {
    path: "/team-bios/amy-bio",
    component: _cffe3db6,
    name: "amy-bio"
  }, {
    path: "/team-bios/drew-bio",
    component: _cffe3db6,
    name: "drew-bio"
  }, {
    path: "/team-bios/janet-bio",
    component: _cffe3db6,
    name: "janet-bio"
  }, {
    path: "/team-bios/jessie-bio",
    component: _cffe3db6,
    name: "jessie-bio"
  }, {
    path: "/team-bios/joseph-bio",
    component: _cffe3db6,
    name: "joseph-bio"
  }, {
    path: "/team-bios/keith-bio",
    component: _cffe3db6,
    name: "keith-bio"
  }, {
    path: "/team-bios/mark-bio",
    component: _cffe3db6,
    name: "mark-bio"
  }, {
    path: "/team-bios/michael-bio",
    component: _cffe3db6,
    name: "michael-bio"
  }, {
    path: "/team-bios/paul-bio",
    component: _cffe3db6,
    name: "paul-bio"
  }, {
    path: "/what-we-do/clients-we-serve",
    component: _cffe3db6,
    name: "clients-we-serve"
  }, {
    path: "/what-we-do/our-process",
    component: _cffe3db6,
    name: "our-process"
  }, {
    path: "/who-we-are/our-alliances",
    component: _cffe3db6,
    name: "our-alliances"
  }, {
    path: "/who-we-are/our-designations",
    component: _cffe3db6,
    name: "our-designations"
  }, {
    path: "/who-we-are/our-team",
    component: _cffe3db6,
    name: "our-team"
  }, {
    path: "/",
    component: _cffe3db6,
    name: "home-page"
  }, {
    path: "/*",
    component: _fe9de024,
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
